var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutoTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.296 2.86 3.16-1.826a.246.246 0 0 1 .37.214v1h1.955a3.948 3.948 0 0 1 3.943 3.943h-1.65a2.295 2.295 0 0 0-2.293-2.293h-1.955v1c0 .19-.204.31-.37.213l-3.16-1.825a.247.247 0 0 1 0-.426Zm4.345 18.568-3.16-1.826a.246.246 0 0 0-.37.214v1H9.156a2.295 2.295 0 0 1-2.293-2.293h-1.65a3.948 3.948 0 0 0 3.943 3.942h1.955v1.001c0 .19.204.31.37.213l3.16-1.825a.248.248 0 0 0 0-.426Zm2.52-10.04a.895.895 0 1 0 .002 1.79.895.895 0 0 0-.001-1.79Zm-9.367 0a.895.895 0 1 0 .001 1.79.895.895 0 0 0 0-1.79ZM20.96 8.503v7.561a1.47 1.47 0 0 1-1.468 1.469H5.469A1.47 1.47 0 0 1 4 16.063v-7.56c0-.811.658-1.47 1.469-1.47h14.023a1.469 1.469 0 0 1 1.468 1.47Zm-1.255 1.59a1.489 1.489 0 0 1-1.807-1.802H6.974c.019.087.028.18.028.273a1.489 1.489 0 0 1-1.747 1.464v4.517a1.489 1.489 0 0 1 1.747 1.464c0 .092-.01.185-.028.273h10.883a1.11 1.11 0 0 1-.014-.185 1.489 1.489 0 0 1 1.853-1.441v-4.563h.009Zm-4.007 2.19a3.225 3.225 0 0 1-3.22 3.22 3.225 3.225 0 0 1-3.22-3.22 3.225 3.225 0 0 1 3.22-3.219c1.774 0 3.22 1.44 3.22 3.22Zm-1.57-.713-.626-.63-1.441 1.432-.602-.607-.63.625.602.607.625.63.63-.625 1.441-1.432Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTransfer);
export default __webpack_public_path__ + "static/media/auto-transfer.23d9271b.svg";
export { ForwardRef as ReactComponent };